import script from "./Sprachtechnik-Course-Maker.vue?vue&type=script&setup=true&lang=js"
export * from "./Sprachtechnik-Course-Maker.vue?vue&type=script&setup=true&lang=js"

import "./Sprachtechnik-Course-Maker.vue?vue&type=style&index=0&id=b4026632&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4026632"]])

export default __exports__